import DataSetInformation from './DataSetInformation';

export default DataSetInformation;
